function validateRamp(rampElement, accessibleRestroomElement, libraryElement, matrix) {
    if (count(rampElement, matrix) < 2) {
        return "Not enough ramps.";
    }
    // every accessible restroom should have a ramp
    let accessibleRestrooms = getElements(accessibleRestroomElement, matrix);
    for (let i=0; i < accessibleRestrooms.length; i++) {
        let r = accessibleRestrooms[i][0];
        let c = accessibleRestrooms[i][1];
        if (r-1 > 0 && matrix[r-1][c] === rampElement) {
            continue;
        } else if (r+1 < matrix.length && matrix[r+1][c] === rampElement) {
            continue
        } else if (c-1 > 0 && matrix[r][c-1] === rampElement) {
            continue
        } else if (c+1 < matrix[r].length && matrix[r][c+1] === rampElement) {
            continue
        } else {
            return "Accessible restroom doesn't have a ramp.";
        }
    }

    // library entrance should have a ramp
    let libaries = getElements(libraryElement, matrix);
    for (let i = 0; i < libaries.length; i++) {
        let r = libaries[i][0];
        let c = libaries[i][1];
        let adjacentElements = [];
        if (r-1 > 0) {
            adjacentElements.push(matrix[r-1][c]);
        }
        if (r+1 < matrix.length) {
            adjacentElements.push(matrix[r+1][c]);
        }
        if (c-1 > 0) {
            adjacentElements.push(matrix[r][c-1]);
        }
        if (c+1 < matrix[r].length) {
            adjacentElements.push(matrix[r][c+1]);
        }
        if (adjacentElements.includes(rampElement)) {
            return "";
        }
    }
    return "Library entrance doesn't have a ramp.";
}


function validateDoor(doorElement, matrix) {
    // check if all sides have a door
    if (!matrix[0].includes(doorElement) || !matrix[matrix.length-1].includes(doorElement)) {
        return "North or south side doesn't have a door.";
    }
    if (!matrix.map(row => row[0]).includes(doorElement) || !matrix.map(row => row[row.length-1]).includes(doorElement)) {
        return "East or west side doesn't have a door.";
    }

    // check if door is double door
    let count = 0;
    for (let c = 0; c < matrix[0].length - 1; c++) {
        if (matrix[0][c] === doorElement && matrix[0][c+1] === doorElement) {
            count++;
        }
        if (matrix[matrix.length-1][c] === doorElement && matrix[matrix.length-1][c+1] === doorElement) {
            count++;
        }
    }
    for (let r = 0; r < matrix.length - 1; r++) {
        if (matrix[r][0] === doorElement && matrix[r+1][0] === doorElement) {
            count++;
        }
        if (matrix[r][matrix[r].length-1] === doorElement && matrix[r+1][matrix[r].length-1] === doorElement) {
            count++;
        }
    }
    if (count < 4) {
        return "Main doors are not wide enough.";
    }
    return "";
}

function getIslands(element, matrix) {
    console.log(matrix)
    // an island is a group of adjacent elements
    // return array containing size of each island

    // init a visited map
    let visited = [];
    for (let i = 0; i < matrix.length; i++) {
        visited.push([]);
        for (let j = 0; j < matrix[i].length; j++) {
            visited[i].push(false);
        }
    }
    // init ans
    let ans = [];

    // bfs
    function bfs(i, j) {
        // if out of bounds, already visited, not correct element, return 0
        if (i < 0 || i >= matrix.length || j < 0 || j >= matrix[i].length || visited[i][j] || matrix[i][j] !== element) {
            return 0;
        }
        // add to visited
        visited[i][j] = true;
        // return 1 + bfs(up) + bfs(down) + bfs(left) + bfs(right)
        return 1 + bfs(i-1, j) + bfs(i+1, j) + bfs(i, j-1) + bfs(i, j+1);
    }

    // loop through matrix
    for (let i = 0; i < matrix.length; i++) {
        for (let j =0; j < matrix[i].length; j++) {
            // if not visited and correct element
            if (!visited[i][j] && matrix[i][j] === element) {
                // bfs
                // push to ans
                ans.push(bfs(i, j));
            }
        }
    }
    return ans;
}

function getElements(element, matrix) {
    // return array of coordinates of element
    let ans = [];
    for (let i = 0; i < matrix.length; i++) {
        for (let j =0; j < matrix[i].length; j++) {
            if (matrix[i][j] === element) {
                ans.push([i, j]);
            }
        }
    }
    return ans;
}

function count(element, matrix) {
    // count number of elements in matrix
    let count = 0;
    for (let i = 0; i < matrix.length; i++) {
        for (let j =0; j < matrix[i].length; j++) {
            if (matrix[i][j] === element) {
                count++;
            }
        }
    }
    return count;
}

export function ruleCheck(matrix) {
    const numRows = 15;
    const numCols = 20;
    const tileToId = {
        'door': 1,
        'classroom': 2,
        'cafeteria': 3,
        'accessible-restroom': 4,
        'restroom': 5,
        'fire-exit': 6,
        'library': 7,
        'ramp': 8
    }
    // validate cafeteria requirement
    let result = getIslands(tileToId['cafeteria'], matrix);
    if (result.length > 1) {
        return "Only one cafeteria is allowed.";
    }
    if (result.length === 0) {
        return "Cafeteria is required.";
    }
    if (result[0] < 16) {
        return "Cafeteria isn't big enough to hold 160 people.";
    }

    // validate classroom requirement
    result = getIslands(tileToId['classroom'], matrix);
    if (result.length < 5) {
        return "Not enough classrooms.";
    }
    for (let i = 0; i < result.length; i++) {
        if (result[i] < 4) {
            return "At least one classroom isn't big enough to hold 40 students.";
        }
    }

    // validate library requirement
    result = getIslands(tileToId['library'], matrix);
    if (result.length !== 1) {
        return "Only one library is needed.";
    }
    if (result[0] < 12) {
        return "Library isn't big enough to hold 120 people.";
    }

    // validate restroom requirement
    if (count(tileToId['restroom'], matrix) < 3) {
        return "Not enough restrooms.";
    }

    // validate accessible restroom requirement
    if (count(tileToId['accessible-restroom'], matrix) < 1) {
        return "Not enough accessible restrooms.";
    }

    // validate door requirement
    result = validateDoor(tileToId['door'], matrix);
    if (result !== "") {
        return result;
    }
    if (count(tileToId['door'], matrix) < 13) {
        return "Not enough doors.";
    }

    // validate fire exit requirement
    if (count(tileToId['fire-exit'], matrix) < 2) {
        return "Not enough fire exits.";
    }
    let fireExits = getElements(tileToId['fire-exit'], matrix);
    const distance = (x1, x2, y1, y2) => Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2);
    let farthestDistance = distance(fireExits[0][0], fireExits[1][0], fireExits[0][1], fireExits[1][1]);
    for (let i = 0; i < fireExits.length; i++) {
        for (let j = i+1; j < fireExits.length; j++) {
            let temp = distance(fireExits[i][0], fireExits[j][0], fireExits[i][1], fireExits[j][1]);
            if (temp > farthestDistance) {
                farthestDistance = temp;
            }
        }
    }
    // farthest distance should be at least 15 units away
    if (farthestDistance < 225) {
        return "Fire exits are too close.";
    }

    // validate ramp requirement
    if (count(tileToId['ramp'], matrix) < 2) {
        return "Not enough ramps.";
    }
    result = validateRamp(tileToId['ramp'], tileToId['accessible-restroom'], tileToId['library'], matrix);
    if (result !== "") {
        return result;
    }
    return "Great job! You passed all the tests!";
}